
import { defineComponent, ref, computed, watchEffect } from 'vue';
import NP from 'number-precision';

export default defineComponent({
  name: 'InputNumber',
  props: {
    modelValue: {
      type: [Number, String],
    },
    placeholder: {
      type: String,
    },
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    disabled: {
      type: Boolean,
    },
    size: {
      type: String,
    },
    precision: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const currentValue = ref<number | string>('');
    const userInput = ref<null | number | string>(null);

    const displayValue = computed(() => {
      if (userInput.value !== null) {
        return userInput.value;
      }

      let _currentValue = currentValue.value;
      const { precision } = props;

      if (typeof _currentValue === 'number') {
        _currentValue = NP.round(_currentValue, precision);
      }
      return _currentValue;
    });

    const toPrecision = (num: number, precision: number) => {
      return NP.round(num, precision);
    };

    const setCurrentValue = (newVal: number | string) => {
      const oldVal = currentValue.value;

      if (typeof newVal === 'number') {
        newVal = toPrecision(newVal, props.precision);
        if (newVal >= props.max) newVal = props.max;
        if (newVal <= props.min) newVal = props.min;
      }
      if (oldVal === newVal) return;
      userInput.value = null;
      emit('update:modelValue', newVal);
      emit('change', newVal, oldVal);
      currentValue.value = newVal;
    };

    watchEffect(() => {
      let newVal = (props.modelValue === '' || props.modelValue === undefined)
        ? props.modelValue
        : Number(props.modelValue);
      if (newVal !== undefined && newVal !== '') {
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(newVal as number)) {
          return;
        }
        newVal = toPrecision(newVal as number, props.precision);
        if (newVal >= props.max) newVal = props.max;
        if (newVal <= props.min) newVal = props.min;
      }
      currentValue.value = newVal as number;
      userInput.value = null;
      emit('update:modelValue', newVal);
    });

    return {
      userInput,
      currentValue,

      displayValue,

      handleInput(value: number) {
        userInput.value = value;
      },
      handleInputChange(value: number | string) {
        const newVal = value === '' ? value : Number(value);
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(newVal as number) || value === '') {
          setCurrentValue(newVal);
        }
        userInput.value = null;
      },
      handleBlur(event: Event) {
        emit('blur', event);
      },
      handleFocus(event: Event) {
        emit('focus', event);
      },
    };
  },
});
